/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef ,useEffect} from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Treadmill/millSupportPlate.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation14.play();
    actions.Animation14.repetitions = 1;
    actions.Animation14.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="supportPlate" geometry={nodes.supportPlate.geometry} material={materials.淺底} />
      </group>
    </group>
  )
}

useGLTF.preload('/Treadmill/millSupportPlate.glb')
